import { Link } from "react-router-dom";

const CustomerSupportComponent = () => {
    return (
<div className="flex pt-[2rem] justify-center text-[#373737] sm:pb-[80px]">
            <div className="max-w-[70rem] mx-auto lg:flex flex-col md:grid  md:flex-row md:gap-[2rem] justify-between items-center lg:mx-[0rem] sm:mx-[0rem] mx-[1.5rem]">
                <div className="flex  gap-6 flex-1 lg:pr-[.2rem] justify-center md:justify-center">
                    <div className="flex flex-col gap-6">
                        <img src="/Home/support3.png" alt="" className="react-reveal lg:w-[17rem] md:w-[14rem] sm:w-[14rem] w-[9rem]"/>
                        <img src="/Home/customersupport1.jpg" alt="" className="react-reveal lg:w-[17rem] md:w-[14rem] sm:w-[14rem] w-[9rem]"/>
                    </div> 
                    <div className="flex flex-col gap-6 mt-[3rem]">
                        <img src="/Home/support2.png" alt="" className="react-reveal lg:w-[17rem] md:w-[14rem] sm:w-[14rem] w-[9rem]"/>
                        <img src="/Home/customersupport2.jpg" alt="" className="react-reveal lg:w-[17rem] md:w-[14rem] sm:w-[14rem] w-[9rem]"/>
                    </div>
                </div>
                <div className="customer-heading flex-1 flex flex-col justify-center lg:mt-12 md:mt-14 md:text-center xl:w-[25rem] lg:w-[20rem] md:w-[35rem] sm:w-[33rem] w-[18rem] mt-[1.5rem]">
                    <div className="flex justify-left md:grid md:justify-left xl:justify-left lg:justify-left items-center">
                        <h1 className="react-reveal font-bold sm:text-4xl text-3xl lg:flex lg:justify-left flex max-w-[24rem] ">Customer Support</h1>
                        
                    </div>
                    <hr className="react-reveal hr  md:mx-0 mx-0  "/>
                    <p className="mt-3 sm:mt-2 md:text-left sm:text-left text-left flex lg:mx-[0rem] mx-[0rem] sm:mx-[0rem] ">
                        With the aim to do better everyday, and to be able to add greater value to our customers' lives, 
                        we have an extensive network of call centres, a WhatsApp response systems, along with a highly motivated 
                        social media team, so we can respond to your queries, inputs, and complaints better. 
                    </p>
                    <div className="lg:flex xl:justify-left lg:justify-left md:justify-left justify-left mb-3 sm:mb-8 mt-[1rem]">
                        <Link to="/customer-services" className="flex justify-left sm:justify-left">
                            <button className="moreBtn transition-all duration-500 gradientbg">Contact Us</button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>

        
    );
};

export default CustomerSupportComponent